/* eslint-disable */
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IImpersonation } from '../interfaces/IImpersonation';
import { IImpersonationToken } from '../interfaces/IImpersonationToken';
import { INotification } from '../interfaces/INotification';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private http = inject(HttpClient);
  private notificationService = inject(NotificationService);

  private impersonationApi = environment.apiUrl + 'Impersonation/';
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  public getImpersonatingUsers(gids?: string[]): Observable<IImpersonation[]> {
    let params = new HttpParams();
    params = params.append('gids', gids ? gids.join(',') : '');
    return this.http
      .get<IImpersonation[]>(this.impersonationApi + 'sources', { ...this.httpOptions, params: gids ? params : null })
      .pipe(catchError(this.handleError<IImpersonation[]>()));
  }

  public getImitableUsers(gid: string): Observable<IImpersonation[]> {
    if (!gid) {
      return of();
    }
    return this.http.get<IImpersonation[]>(this.impersonationApi + 'targets/' + gid, this.httpOptions).pipe(
      map((impersonations: IImpersonation[]) =>
        impersonations.filter((impersonation: IImpersonation) => new Date(impersonation.validTo) > new Date()),
      ),
      catchError(this.handleError<IImpersonation[]>()),
    );
  }

  public impersonateUser(impersonation: IImpersonation): Observable<IImpersonationToken> {
    const impersonate = {
      gid: impersonation.parentGid,
    };

    return this.http.post<IImpersonationToken>(this.impersonationApi + 'Impersonate', impersonate, this.httpOptions).pipe(
      catchError(
        this.handleError<IImpersonationToken>('impersonationFailed', {
          user: impersonation.parentName ?? impersonation.parentGid,
        }),
      ),
    );
  }

  public addImpersonation(impersonation: IImpersonation): void {
    this.http
      .post(this.impersonationApi, impersonation, this.httpOptions)
      .pipe(
        catchError(
          this.handleError('impersonationAddingFailed', {
            user: impersonation.parentName ?? impersonation.parentGid,
          }),
        ),
      )
      .subscribe(() => {
        this.displaySuccessMessage('notifications.impersonation.impersonationAdded', {
          user: impersonation.parentName ?? impersonation.parentGid,
        });
      });
  }

  public deleteImpersonatingUser(impersonation: IImpersonation): void {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: impersonation,
    };
    this.http
      .delete(this.impersonationApi, httpOptions)
      .pipe(
        catchError(
          this.handleError('impersonationDeletionFailed', {
            user: impersonation.parentName ?? impersonation.parentGid,
          }),
        ),
      )
      .subscribe(() => {
        this.displaySuccessMessage('notifications.impersonation.impersonationDeleted', {
          user: impersonation.parentName ?? impersonation.parentGid,
        });
      });
    /*
     */
  }

  private handleError<T>(operation?: string, data?: object): (error: any) => Observable<T> {
    return (error: any): any => {
      const notification: INotification = {
        type: 'Error',
        title: 'header.userSettings.impersonation.impersonation',
        desc: operation,
      };
      this.notificationService.showMessage(notification, data);

      console.error(error);
      return of(error as Observable<any>);
    };
  }

  private displaySuccessMessage(message: string, data: object): void {
    const notification: INotification = {
      type: 'Success',
      title: 'header.userSettings.impersonation.impersonation',
      desc: message,
    };
    this.notificationService.showMessage(notification, data);
  }
}
